import React from "react"
import { injectIntl } from "react-intl"
import LabelBadge from "../../common/label/badge.component"
import { STOCK_IMPORT_STATUS, StockImportStatus } from "../../common/types/inventory"
import IntlProps from "../../state/helpers/IntlProps"
import { STOCK_IMPORTS_LISTING_STATUS_MESSAGES } from "../../utils/inventory"

type ImportStatusComponentProps = {
    status: StockImportStatus
}

const ImportStatusComponent = (props: ImportStatusComponentProps & IntlProps) => {
    switch(props.status) {
    case STOCK_IMPORT_STATUS.IN_PROGRESS:
        return (
            <span className={LabelBadge.getBadgeClassName(props.status)}>
                {props.intl.formatMessage(STOCK_IMPORTS_LISTING_STATUS_MESSAGES[STOCK_IMPORT_STATUS.IN_PROGRESS])}
            </span>
        )
    case STOCK_IMPORT_STATUS.COMPLETED:
        return (
            <span className={LabelBadge.getBadgeClassName(props.status)}>
                {props.intl.formatMessage(STOCK_IMPORTS_LISTING_STATUS_MESSAGES[STOCK_IMPORT_STATUS.COMPLETED])}
            </span>
        )
    case STOCK_IMPORT_STATUS.CREATED:
        return (
            <span className={LabelBadge.getBadgeClassName(props.status)}>
                {props.intl.formatMessage(STOCK_IMPORTS_LISTING_STATUS_MESSAGES[STOCK_IMPORT_STATUS.CREATED])}
            </span>
        )
    case STOCK_IMPORT_STATUS.ERROR:
        return (
            <span className={LabelBadge.getBadgeClassName(props.status)}>
                {props.intl.formatMessage(STOCK_IMPORTS_LISTING_STATUS_MESSAGES[STOCK_IMPORT_STATUS.ERROR])}
            </span>
        )
    default:
        return <span />
    }
}

export default injectIntl(ImportStatusComponent)


// WEBPACK FOOTER //
// ./src/inventory/components/ImportStatusComponent.tsx